import React from 'react'
import { withRouter } from "react-router-dom"
import {StyledCardButton} from "./linkButton.style"

const LinkButton = (props) => {
    const {
        history,
        location,
        match,
        staticContext,
        to,
        onClick,
        ...rest
    } = props
    return (
        <StyledCardButton
            {...rest}
            onClick={(event) => {
                onClick && onClick(event)
                history.push(to)
            }}
        />
    )
}

export default withRouter(LinkButton)